import { keepPreviousData as e, useQuery as t } from "@tanstack/react-query";
import { http as n, toQueryParams as r } from "@frontends/data-access-spg-api";
//#region src/lib/api/decisionsApi.ts
function i(e) {
	let t = e.participation?.user;
	return {
		id: e.id,
		participationId: e.participation_id,
		instanceId: e.instance_id,
		type: e.type,
		reasonCode: e.reason_code,
		evidence: e.evidence ?? {},
		entryFlowId: e.entry_flow_id,
		retentionRuleId: e.retention_rule_id,
		scanRunId: e.scan_run_id,
		initiatorId: e.initiator_id,
		initiatorType: e.initiator_type,
		previousStatus: e.previous_status,
		newStatus: e.new_status,
		applicationStatus: e.application_status,
		applicationReason: e.application_reason,
		createdAt: e.created_at,
		appliedAt: e.applied_at,
		person: t ? {
			platform: t.platform,
			externalId: t.external_id,
			displayName: t.display_name,
			username: t.username
		} : null
	};
}
async function a(e, t, a) {
	let { data: o } = await n.get("/decisions", {
		params: {
			...r(e, t),
			preload: "participation,participation.user"
		},
		signal: a
	});
	return {
		data: o.data.map(i),
		total: o.total
	};
}
//#endregion
//#region src/lib/queries.ts
var o = {
	entry: [
		"check_started",
		"rejection",
		"grant",
		"join_confirmed",
		"return",
		"evaluated_no_change"
	],
	risk: ["warning", "risk_cleared"],
	removal: ["removal", "block"],
	operator: [
		"unblock",
		"exempted",
		"exemption_lifted"
	]
};
function s(e) {
	let t = [], n = (e, n) => {
		n && t.push({
			field: e,
			op: "eq",
			value: n
		});
	};
	return n("instance_id", e.instanceId), n("participation_id", e.participationId), n("retention_rule_id", e.ruleId), n("scan_run_id", e.runId), e.kind && t.push({
		field: "type",
		op: "in",
		value: [...o[e.kind]]
	}), e.failedOnly && t.push({
		field: "application_status",
		op: "eq",
		value: "not_applied"
	}), e.from && t.push({
		field: "created_at",
		op: "gte",
		value: e.from
	}), e.to && t.push({
		field: "created_at",
		op: "lt",
		value: e.to
	}), t;
}
var c = {
	all: ["decisions"],
	list: (e, t) => [
		...c.all,
		"list",
		e,
		t
	]
};
function l(n, r) {
	return t({
		queryKey: c.list(n, r),
		queryFn: ({ signal: e }) => a(n, s(r), e),
		placeholderData: e
	});
}
//#endregion
export { o as DECISION_KINDS, c as decisionsQueryKeys, l as useDecisionsQuery };
